export default __webpack_public_path__ + "static/media/goal.10fbae5e.png";